export default __webpack_public_path__ + "1f3a0c9a86ac5d557f3178ccb8806803.svg";